const estados = {
    CAJA_REGISTRADA: {
        id: "CRE",
        descripcion: "Caja registrada",
        class: "nj-tag"
    },
    CAJA_POR_APROBAR: {
        id: "CPA",
        descripcion: "Caja por aprobar",
        class: "nj-tag c-yellow"
    },
    CAJA_APROBADA: {
        id: "CAP",
        descripcion: "Caja aprobada",
        class: "nj-tag c-green"
    },
    CAJA_DESAPROBADA: {
        id: "CDE",
        descripcion: "Caja desaprobada",
        class: "nj-tag c-red"
    },
    CAJA_CANCELADA: {
        id: "CCA",
        descripcion: "Caja cancelada",
        class: "nj-tag c-red"
    },
    CAJA_DEPOSITADA: {
        id: "CDP",
        descripcion: "Depositado / Por Rendir",
        class: "nj-tag c-purple"
    },
    RENDICION_POR_APROBAR: {
        id: "RPA",
        descripcion: "Rendicion por aprobada",
        class: "nj-tag c-yellow"
    },
    RENDICION_APROBADA: {
        id: "RAP",
        descripcion: "Rendicion aprobada",
        class: "nj-tag c-green"
    },
    RENDICION_DESAPROBADA: {
        id: "RDE",
        descripcion: "Rendicion desaprobada",
        class: "nj-tag c-red"
    },
    ORDEN_PAGO_REGISTRADA: {
        id: "OPR",
        class: "nj-tag"
    },
    ORDEN_PAGO_POR_APROBAR: {
        id: "OXA",
        class: "nj-tag c-yellow"
    },
    ORDEN_PAGO_APROBADA: {
        id: "OPA",
        class: "nj-tag c-green"
    },
    ORDEN_PAGO_DESAPROBADA: {
        id: "OPD",
        class: "nj-tag c-red"
    },
    ORDEN_PAGO_CANCELADA: {
        id: "OPC",
        class: "nj-tag c-red"
    },
    ORDEN_PAGO_DEPOSITADA: {
        id: "OPP",
        class: "nj-tag c-purple"
    },
}

const colorsTag = [
    {
        id: "OPA",
        class: "nj-tag c-green"
    },
    {
        id: "CRE",
        class: "nj-tag"
    },
    {
        id: "CPA",
        class: "nj-tag c-yellow"
    },
    {
        id: "CAP",
        class: "nj-tag c-green"
    },
    {
        id: "CDE",
        class: "nj-tag c-red"
    },
    {
        id: "CCA",
        class: "nj-tag c-red"
    },
    {
        id: "CDP",
        class: "nj-tag c-purple"
    },
    {
        id: "RPA",
        class: "nj-tag c-yellow"
    },
    {
        id: "RAP",
        class: "nj-tag c-green"
    },
    {
        id: "RDE",
        class: "nj-tag c-red"
    },
    {
        id: "OPR",
        class: "nj-tag"
    },
    {
        id: "OXA",
        class: "nj-tag c-yellow"
    },
    {
        id: "OPA",
        class: "nj-tag c-green"
    },
    {
        id: "OPD",
        class: "nj-tag c-red"
    },
    {
        id: "OPC",
        class: "nj-tag c-red"
    },
    {
        id: "OPP",
        class: "nj-tag c-purple"
    },
]

function getColorTag(id) {
    const color = colorsTag.find(item => item.id == id)
    if (!color) return
    return color.class
}

function ordenPagoEstado(id) {
    let clazz = ""
    switch (id) {
        case 1:
            clazz = "nj-tag"
            break
        case 2:
            clazz = "nj-tag c-yellow"
            break
        case 3:
            clazz = "nj-tag c-green"
            break
        case 4:
            clazz = "nj-tag c-red"
            break
        case 5:
            clazz = "nj-tag c-red"
            break
        case 6:
            clazz = "nj-tag c-purple"
            break
    }
    return clazz
}

function productoEstado(id) {
    let clazz = ""
    switch (id) {
        case 0:
            clazz = "nj-tag c-red"
            break
        case 1:
            clazz = "nj-tag c-green"
            break
    }
    return clazz
}

export {
    estados,
    getColorTag,
    ordenPagoEstado,
    productoEstado,
}